export const jump = {
  id: 'jump',
  state: 'jump',
  system: false,

  enter(ctx) {
    ctx.movement.jump();
  },

  update(ctx) {
    if (ctx.movement.isGrounded() && ctx.stateTime > 100) {
      ctx.transition('idle');
    }
  },

  exit() {},
};
